"use client";

import React, { createContext, ReactNode } from "react";
import { toast, Toaster } from "react-hot-toast";

export type ToastContextType = {
  success: (msg: string) => void;
  error: (msg: string) => void;
  info: (msg: string) => void;
};

export const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const toastFunctions: ToastContextType = {
    success: (msg: string) => toast.success(msg, { duration: 4000 }),
    error: (msg: string) => toast.error(msg, { duration: 4000 }),
    info: (msg: string) => toast(msg, { duration: 4000 }),
  };

  return (
    <ToastContext.Provider value={toastFunctions}>
      {children}
      <Toaster 
        position="top-center" 
        reverseOrder={false}
      
      />
    </ToastContext.Provider>
  );
};


export const useToast = () => {
  const context = React.useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};